<div class="map-preview-container" 
    [style]="{ height: previewHeight, width: previewWidth }"
    [ngClass]="{ visible: previewMapReady, invisible: !previewMapReady }">
    <div
        *ngIf="isGoogleKeyEnabled && (mapService.readyGoogleMapsMapChanged | async)"
        id="gm-preview"
        class="gmPreview"
        [ngClass]="{ show: activeMap==mapService.SHOW_GOOGLE_MAPS, hide: activeMap==mapService.SHOW_OPEN_LAYERS}">
        <google-map #googleMapPreview height="100%" width="100%"
            [center]="{ lat: mapService.mapCenter[1], lng: mapService.mapCenter[0] }"
            [zoom]="mapService.mapZoom - previewZoomOverflow" [options]="previewGoogleMapsOptions">
        </google-map>
    </div>

    <div id="ol-preview" class="olPreview">
        <div id="ol-preview-map" class="w-100 h-100"></div>
    </div>

</div>